import { render, staticRenderFns } from "./VouchersShow.vue?vue&type=template&id=53c10dd2&"
import script from "./VouchersShow.vue?vue&type=script&lang=js&"
export * from "./VouchersShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports